import { Link } from 'react-router-dom';
import styles from './Footer.module.scss';
import footerLogo from '../../screen/images/footer-logo.png';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.top}>
          <div className={styles.brand}>
            <img src={footerLogo} alt="G-WORKS" className={styles.logo} />
            <p className={styles.desc}>
              디자인앤컴퍼니 G-WORKS는 브랜드, 판촉물, 패키지, 웹디자인 포트폴리오 노출과 견적·주문·결제를 하나로 통합한
              디자인 플랫폼입니다.
            </p>
          </div>
          <div className={styles.cols}>
            <div>
              <h5>바로가기</h5>
              <Link to="/company">회사소개</Link>
              <Link to="/works">포트폴리오</Link>
              <Link to="/order">주문하기</Link>
              <Link to="/mypage">마이페이지</Link>
            </div>
            <div>
              <h5>고객 지원</h5>
              <Link to="/lookup">주문조회</Link>
              <Link to="/quote">견적문의</Link>
              <Link to="/faq">자주묻는질문</Link>
            </div>
            <div>
              <h5>CONTACT</h5>
              <a href="tel:0532164126">053-216-4126</a>
              <a href="mailto:gn-co@daum.net">gn-co@daum.net</a>
              <span className={styles.addr}>경상북도 구미시 선산읍 선주로 129-60</span>
            </div>
          </div>
        </div>
        <div className={styles.divider} />
        <p className={styles.bizInfo}>주식회사 G-WORKS | 대표 변수영 | 사업자등록번호 : 655-88-00579</p>
        <p className={styles.copyright}>&copy; {year} G-WORKS. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
